import { Button, Grid, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import WSIconCard from "../../Components/IconCard/WSIconCard";
import { WSIcons } from "../../commonFunctions/iIcons";
import {OrderPage} from "./OrderPage";
import CartDrawer from "./OrderInfoDrawer";
import { useNavigate } from "react-router-dom";
import { SelectOrderType } from "./SelectOrderType";

export const DineInNewKotHeader: React.FC<any> = React.memo((props) => {
  const [cartOpen, setCartOpen] = useState(false);
  const [orderTypeOpen, setOrderTypeOpen] = useState(false);
  const [selectedOrderType, setSelectedOrderType] = useState<string>('Dine In');
const navigate = useNavigate()
  const handleClick = (path:string) =>{
   navigate(path)
  }

  const handleCartClick = () => {
    setCartOpen(true);
  };

  const handleCartClose = () => {
    setCartOpen(false);
  };


  const handleClickOpen = () => {
    setOrderTypeOpen(true); // Open the order type dialog
  };

  const handleClose = () => {
    setOrderTypeOpen(false); // Close the order type dialog
  };

  const handleOrderTypeSelect = (orderType: string) => {
    setSelectedOrderType(orderType); // Update the selected order type
    handleClose(); // Close the dialog after selection
  };
  return (
    <Grid>
      <Grid sx={{  padding: 1 }}>
        <Grid container alignItems={'center'} spacing={4}> {/* Removed spacing between items */}
          {/* Menu Button */}
          <Grid item>
            <Tooltip title="order info">
            <Button sx={{ backgroundColor: 'white', color: 'black', minWidth: '50px' }}> {/* Reduced width */}
              <WSIcons.Threedot onClick={handleCartClick}/>
            </Button>
            </Tooltip>
            <CartDrawer open={cartOpen} onClose={handleCartClose} />

          </Grid>

          <Grid item>
  <Grid 
    container 
    sx={{ 
      backgroundColor: 'white', 
      color: 'black', 
      minWidth: '100px', 
      justifyContent: "center", 
      alignItems: "center",
      height:"2rem" 
    }} 
  >
    {selectedOrderType}  <WSIcons.KeyboardArrowDownIcon onClick={handleClickOpen}/>
  </Grid>
</Grid>


<Grid item>
  <Grid 
    container 
    sx={{ 
      backgroundColor: 'white', 
      color: 'black', 
      minWidth: '100px', 
      justifyContent: "center", 
      alignItems: "center",
      height:"2rem" 
    }} 
  >
    New Receipt 
  </Grid>
</Grid>


          {/* Information (Server, Table, Guest) */}
          <Grid item sx={{ marginLeft: '10rem', display: 'flex', gap: 8,  }}>
            <Typography variant="body2">Server Roh</Typography>
            <Typography variant="body2">Table Room 104</Typography>
            <Typography variant="body2">Guest Andrew</Typography>
          </Grid>

          {/* Spacer */}
          <Grid item xs />

          {/* Close Button */}
          <Grid item>
            <Button sx={{ backgroundColor: 'red', color: 'white' }}>
              <WSIcons.CloseIcon onClick={()=>handleClick('/')}/>
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <OrderPage/>
      <SelectOrderType
        open={orderTypeOpen}
        onClose={handleClose}
        selectedOrderType={selectedOrderType} // Pass selected order type to dialog
        onSelectOrderType={handleOrderTypeSelect} // Handle order type selection
      />      
      
      </Grid>
  );
});
